import {Stack, Typography} from '@mui/material'
import React from 'react'
import Label from '../../customTable/Label'
import LabelWithValue from './LabelWithValue'
import {useTranslation} from 'react-i18next'

const GATEWAY_DISPLAY_NAMES: Record<string, string> = {
  PY_WHISH: 'Whish Money',
  PY_BLOM: 'BLOM Bank',
  PY_BLOM_UC: 'BLOM Bank',
  PY_OMT: 'OMT Pay',
  PY_ZAINCASH: 'ZainCash',
  PY_QICARD: 'Qi Card',
  PY_CASH: 'Cash',
}

const REGISTRATION_NUMBER = '1033430'
const TEXT_SECONDARY = 'var(--text-secondary, #65656A)'

function gatewayDisplayName(payment_method: string | null | undefined): string {
  if (!payment_method) {
    return '—'
  }

  const key = String(payment_method).trim()
  const upper = key.toUpperCase()

  // Never show legacy Konin Pay for gateway factory codes
  if (upper === 'PY_KONINPAY' || upper === 'KONINPAY' || upper === 'KONIN PAY') {
    return '—'
  }

  return GATEWAY_DISPLAY_NAMES[key] || GATEWAY_DISPLAY_NAMES[upper] || key
}

function RawRow({label, value}: {label: string; value: string}) {
  const {t} = useTranslation()
  return (
    <Stack justifyContent='space-between' direction='row' gap='16px'>
      <Typography sx={{fontSize: '16px', fontWeight: 400, color: '#19224C'}}>
        {t(label)}
      </Typography>
      <Typography sx={{fontSize: '16px', fontWeight: 400, color: '#19224C', textAlign: 'end'}}>
        {value}
      </Typography>
    </Stack>
  )
}

/**
 * Invoice detail modal — registration, actual gateway, VAT note under total.
 */
export default function Detailes({item}: any) {
  const {t} = useTranslation()
  const invoiceId = item.num || item.id || '—'
  const methodLabel = gatewayDisplayName(item.payment_method)
  const subtotal = item.subtotal != null && item.subtotal !== '' ? Number(item.subtotal) : null
  const currency = localStorage.getItem('currency') || ''

  return (
    <Stack p={{xs: '24px', sm: '40px'}}>
      <Stack borderBottom='1px dashed #a9a9a9' pb='24px'>
        <Label fw='500' fs='24px' text='invoiceDetails' />
      </Stack>
      <Stack gap='24px' borderBottom='1px dashed #a9a9a9' p='24px 0'>
        <RawRow label='invoicesID' value={String(invoiceId)} />
        <RawRow label='registrationNumber' value={REGISTRATION_NUMBER} />
        <LabelWithValue value={item.type || '—'} label='type' />
        <RawRow label='date' value={String(item.created_at || '—')} />
        <RawRow label='paymentMethod' value={methodLabel} />
      </Stack>
      <Stack gap='24px' borderBottom='1px dashed #a9a9a9' p='24px 0'>
        {item.fees != null && item.fees !== '' ? (
          <LabelWithValue isPrice value={item.fees} label='fees' />
        ) : null}
        {subtotal != null && !Number.isNaN(subtotal) ? (
          <LabelWithValue isPrice value={subtotal} label='subTotal' />
        ) : null}
        <LabelWithValue isPrice value={item.total} label='amountPaid' />
      </Stack>
      <Stack pt='24px' gap='0' alignItems='stretch'>
        <Stack alignItems='center' gap='5px' justifyContent='flex-end' direction='row' pb='8px'>
          <Label fw='600' fs='16px' text='total' /> :{' '}
          <Label
            fw='700'
            fs='20px'
            text={`${item.total && Number(item.total).toFixed(2)}${currency}`}
          />
        </Stack>
        <Typography
          sx={{
            fontSize: '12px',
            color: TEXT_SECONDARY,
            textAlign: 'end',
            mt: '12px',
            pt: '8px',
            borderTop: '1px solid var(--border, #E0E0E0)',
          }}
        >
          {t('vat_note')}
        </Typography>
      </Stack>
    </Stack>
  )
}
